/* eslint-disable max-len */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import React from 'react';

export default function AssignedASE({ OrderDetails }) {
    return (
        <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4 assigned1">
            <p className="font-semibold text-base text-[#090406] assigned">Assigned ASE(s)</p>
            {(OrderDetails.ASEs).length > 0 && (OrderDetails.ASEs) !== null
                ? (
                    <div>
                        {(OrderDetails.ASEs).map((item) => (
                            <div className="flex mt-3">
                                <img src="/images/Profile6.png" alt="icon" className="w-[26px] h-[26px]" />
                                <div className="pl-2">
                                    <p className="text-lg font-normal text-[#303030]">
                                        {item?.FIRST_NAME || item?.first_name }
                                        {' '}
                                        {item?.LAST_NAME || item?.last_name}
                                    </p>
                                    {OrderDetails.ASEs !== null
                                        ? (
                                            <p className="text-xs12 font-semibold text-[#707070]">
                                                <span>{item?.EMPLOYEE_CODE || item?.employee_code}</span>
                                                {' - '}
                                                {item?.PRODUCT_CATEGORIES
                                                    ? <span>{item.PRODUCT_CATEGORIES?.toLocaleString() || item.product_categories?.toLocaleString()}</span>
                                                    : <span>{' '}</span>}

                                            </p>
                                        ) : null }
                                </div>
                            </div>

                        ))}
                    </div>
                )
                : (
                    <div className="flex mt-3">
                        No ASE Assigned!
                    </div>
                )}

        </div>
    );
}
